@if (onRoot()) {
  @if (smallDevice()) {
    <div class="actions">
      <button
        smw-button
        kind="icon"
        class="menu"
        [icon]="menuIcon"
        (click)="openSidebar.emit()"
      ></button>
      <div #content id="secondaries"></div>
    </div>
  }

  @if (mediumDevice() || largeDevice()) {
    <div #content id="back"></div>
    <div class="actions">
      <div #content id="secondaries"></div>
      <div #content id="primary"></div>
    </div>
  }
} @else {
  @if (smallDevice()) {
    <div #content id="back"></div>
    <div class="actions">
      <div #content id="secondaries"></div>
      <div #content id="primary"></div>
    </div>
  }

  @if (mediumDevice() || largeDevice()) {
    <div #content id="back"></div>
    <div class="actions">
      <div #content id="secondaries"></div>
      <div #content id="primary"></div>
    </div>
  }
}
